import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router, public jwtHelper: JwtHelperService) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    /**
     * Valida si se puede decodificar el token
    **/
    try {
      this.jwtHelper.decodeToken(localStorage.getItem('access_token'));
    } catch (error) {
      return false;
    }
    /**
     * Valida si s epuede verificar si el token ha expirado
    **/
    try {
      this.jwtHelper.isTokenExpired();
    } catch (error) {
      return false;
    }
    /**
     * Valida si el token ha expirado
    **/
    if (this.jwtHelper.isTokenExpired()) {
      return false;
    }

    /**
     * Valida si existe el token en localStorage
    **/
    if (localStorage.getItem('access_token')) {
      return true;
    }

    /**
     * Redirige al login si nada se cumple
    **/
    this.router.navigate(['login']);
    return false;
  }
}
